export default values => ({
  ...values,
  invoicePdfUrl: values.invoicePdfUrl || '',
  invoiceXmlUrl: values.invoiceXmlUrl || '',
  serialNumber: values.serialNumber || ''
});
